
import Vue from "vue";
export default Vue.extend({
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    primaryButtonText: {
      type: String,
      default: ""
    }
  },
  watch: {
    showModal(newValue) {
      if (newValue) {
        this.$modal.show("discard-changes-modal");
      }
    }
  }
});
